import { $, type Html, html, rune, View } from 'rune-ts';
import klass from './CommunitySection.module.scss';
import { font, staticFont } from '@services/MarppleShop/shared/typography';
import { map, pipe, toArray } from '@fxts/core';
import { getResizedUrl } from '@services/MarppleShop/shared/util/image.ts';
import { EffectFade, Navigation } from 'swiper/modules';
import Swiper from 'swiper';

export class CommunitySection extends View {
  swiper?: Swiper;
  current_index = 1;
  max_index = 3;

  constructor() {
    super({});
  }

  override template(): Html {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;
    const services = [
      {
        img_url:
          '//s3.marpple.co/files/u_4648126/2025/6/original/69867bffaab4ed7e6835de75d7f5f00ece0047b34.png',
        title: '멤버십',
        desc: is_mobile
          ? '멤버십 기능을 통해 팬 전용 혜택 및 한정 굿즈를 판매할 수 있어요. 팬 전용 공간을 열어 팬분들과의 유대감을 더 높여보세요!'
          : html.preventEscape(
              `멤버십 기능을 통해 팬 전용 혜택 및 한정 굿즈를 판매할 수 있어요.<br/>팬 전용 공간을 열어 팬분들과의 유대감을 더 높여보세요!`,
            ),
      },
      {
        img_url:
          '//s3.marpple.co/files/u_4648126/2025/6/original/5ffe6aa3c4cc6ad7ef36d7be6ccd123120674a593.png',
        title: '후원',
        desc: is_mobile
          ? '후원 기능으로 나의 창작 활동을 응원받을 수 있어요. 후원해준 팬들에게 감사 메시지를 보내 따뜻한 연결을 만들어 보세요!'
          : html.preventEscape(
              `후원 기능으로 나의 창작 활동을 응원받을 수 있어요.<br/>후원해준 팬들에게 감사 메시지를 보내 따뜻한 연결을 만들어 보세요!`,
            ),
      },
      {
        img_url:
          '//s3.marpple.co/files/u_4648126/2025/6/original/f5dbc9c42e8f53c867b62b1eddb87dfc207f2bcd2.png',
        title: '펀딩',
        desc: is_mobile
          ? '펀딩 기능으로 목표를 설정하고 팬들과 함께 달성해 보세요. 목표를 달성하면 특별한 혜택을 받을 수 있어요!'
          : html.preventEscape(
              `펀딩 기능으로 목표를 설정하고 팬들과 함께 달성해 보세요.<br/>목표를 달성하면 특별한 혜택을 받을 수 있어요!`,
            ),
        plus_img_url:
          '//s3.marpple.co/files/u_4648126/2025/6/original/234a4319297d2ee48009302c8a713f6bc746f65a1.png',
      },
    ];

    return html`
      <section class="${klass.container} swiper_community">
        <div class="${klass.title}">
          <div class="${staticFont('bebas_20_bold')}">CHAPTER 3.</div>
          <div class="${font('48_bold', '28_bold')}">
            ${html.preventEscape(`멤버십, 후원, 펀딩 기능을 통해<br/>팬들과의 관계를 좁혀보세요`)}
          </div>
        </div>
        ${is_mobile
          ? html`
              <div class="${klass.service_list} swiper-wrapper">
                ${pipe(
                  services,
                  map(({ img_url, title, desc }) => {
                    return html`
                      <div class="${klass.feature} swiper-slide">
                        <img
                          src="${getResizedUrl({
                            url: img_url,
                            width: 327 * 2,
                            quality: 85,
                            format: 'webp',
                          })}"
                          class="${klass.feature_img}"
                          alt="상품 이미지"
                        />
                        <div class="${klass.content}">
                          <div class="${font('24_bold')}">${title}</div>
                          <div class="${font('16_medium')} ${klass.desc}">${desc}</div>
                        </div>
                      </div>
                    `;
                  }),
                  toArray,
                )}
              </div>
              <div class="pagination ${klass.pagination} ${staticFont('bebas_14_bold')}">
                <span class="current_index"> 0${this.current_index} </span>
                <div class="${klass.pages}">
                  <div class="progress ${klass.page}" style="width: ${this.calcProgress()}%;"></div>
                </div>
                <span> 0${this.max_index} </span>
              </div>
            `
          : html`
              <div class="${klass.service_list}">
                ${pipe(
                  services,
                  map(({ img_url, title, desc, plus_img_url }) => {
                    return html`
                      <div class="${klass.feature}">
                        <img
                          src="${getResizedUrl({
                            url: img_url,
                            width: 420 * 2,
                            quality: 85,
                            format: 'webp',
                          })}"
                          class="${klass.feature_img}"
                          alt="상품 이미지"
                        />
                        <div class="${klass.content}">
                          <div class="${font('24_bold')}">${title}</div>
                          <div class="${font('16_medium')} ${klass.desc}">${desc}</div>
                        </div>
                        ${plus_img_url
                          ? html`<img
                              src="${getResizedUrl({
                                url: plus_img_url,
                                width: 250 * 2,
                                quality: 85,
                                format: 'webp',
                              })}"
                              class="${klass.plus_img}"
                              alt="상품 이미지"
                            />`
                          : ''}
                      </div>
                    `;
                  }),
                  toArray,
                )}
              </div>
            `}
      </section>
    `;
  }

  override onRender() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    if (is_mobile) this.swiper = this._onLoadSwiper();
  }

  private _onLoadSwiper() {
    return new Swiper('.swiper_community', this._createSwiperOption());
  }

  private _createSwiperOption() {
    return {
      modules: [Navigation, EffectFade],
      loop: true,
      spaceBetween: 24,
      on: {
        slideChange: (swiper: Swiper) => {
          this.setCurrentIndex(swiper.realIndex + 1);
          this.redraw();
        },
      },
    };
  }

  calcProgress() {
    return ((this.current_index + 1) / (this.max_index + 1)) * 100;
  }

  setCurrentIndex(index: number) {
    this.current_index = index;
  }

  override redraw(): this {
    $(this.element()).find('.current_index')?.setInnerHtml(`0${this.current_index.toString()}`);
    const progress = $(this.element()).find('.progress')?.element();
    if (progress) progress.style.width = `${this.calcProgress()}%`;

    return this;
  }
}
